exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 42px;\n}\n@media only screen and (max-width: 1024px) {\n.block-wrapper {\n    gap: 24px;\n}\n}\n", ""]);

// exports
